import {Injectable} from '@angular/core';
import {AuthHttpService} from "../../../../../services/auth-http.service";
import {HttpParams, HttpResponse} from "@angular/common/http";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {Globals} from '../../../../../globals';
import {forkJoin} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {LaneTypesService} from "./lane-types.service";
import {SortTableService} from "../../../services/sort-table.service";
import {DialogRoadLaneComponent} from '../../../dialogs/dialog-road-lane/dialog-road-lane.component';

@Injectable({
  providedIn: 'root'
})
export class RoadTypesService {
  public error_data: any;
  public created: any;
  public road_type: any;
  public updated: any;
  public privileges: any;
  public roadTypeSel: any;
  public no_access: boolean;
  public edit_allowed: boolean;
  public roadTypes: any;
  public laneTypes: any;
  public roadLanes: any;
  public isDataAvailable: boolean;
  public projList: any = [];
  private delete: any;
  private deleted: any;
  private readonly changeLangCancel: any;
  public selRoadType: any;
  public newRoadType: null;
  public sensorId: any;
  private road_parameters: any;
  roads: any = [];
  sensors: any = [];
  disableButton: boolean;
  allRoadTypes: any = [];
  public roadType: any;


  constructor(
    private http: AuthHttpService,
    public Globals: Globals,
    public dialog: MatDialog,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    public laneTypesService: LaneTypesService,
    public sortTableService: SortTableService,
  ) {
    //translate
    this.Globals.langJS.subscribe(() => {
      this.onLangChanged();
      this.translate.use(this.Globals.lang)
    });
  }

  async onLangChanged() {
    this.translateRoadTypeName();
    forkJoin([
      this.translate.get('error_data'), // 0
      this.translate.get('created'), // 1
      this.translate.get('road_type'), // 2
      this.translate.get('updated'), // 3
      this.translate.get('ad_ro_ma_Delete'),//4
      this.translate.get('deleted'),//4
      this.translate.get('road_parameters'),//5
    ]).subscribe((res) => {
      this.error_data = res[0];
      this.created = res[1];
      this.road_type = res[2];
      this.updated = res[3];
      this.delete = res[4];
      this.deleted = res[5];
      this.road_parameters = res[6];
    })
  }

  public async getDataByDefault() {
    this.Globals.error = true;
    if (Boolean(this.Globals.user)) {
      this.no_access = false;
      this.edit_allowed = this.privileges;
      this.projList = !this.projList.length ? await this.laneTypesService.getProjectList() : this.projList;
      this.roadTypes = await this.fetchRoadTypes();
      this.allRoadTypes = await this.fetchAllRoadTypesCodes();
      this.translateRoadTypeName();
      this.isDataAvailable = true
    }
  }

  /**
   * Translate road type name.
   */
  translateRoadTypeName() {
    const lang = this.Globals.lang;
    if (this.roadTypes) {
      this.roadTypes.map(road => {
        if (lang in road.road_name) {
          road.name = road.road_name[lang];
        }
      })
    }
    this.roadTypes = this.sortTableService.sortDataByParameter(this.roadTypes, 'name');
  }

  /**
   * Get road types.
   */
  public async fetchRoadTypes() {
    try {
      let res = await this.http.get('/api/road-types/get-road-types').toPromise();
      res.body.forEach(road => {
        road.road_name = JSON.parse(road.road_name);
      })
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Create new road type.
   * @param createParams
   */
  public async createRoadTypeRequest(createParams: any) {
    this.sendDataAndCreateDialog(
      '/api/road-type/create-road-type',
      createParams,
      `${this.road_type} ${this.created.toLowerCase()}`,
      false,
      true
    );
  }

  /**
   * Update road type by road_types_id.
   * @param updateParams
   */
  public async updateRoadTypeRequest(updateParams: any) {
    this.sendDataAndCreateDialog(
      '/api/road-type/update-road-type',
      updateParams,
      `${this.road_type} ${this.updated.toLowerCase()}`,
      false,
      true,
    );
  }

  public createCopyOfRoadTypeRequest(createParams: any) {
    this.sendDataAndCreateDialog(
      '/api/road-type/copy-road-type',
      createParams,
      `${this.road_type} ${this.created.toLowerCase()}`,
      false,
      true
    );
  }

  /**
   * Delete road type by road_types_id.
   * @param roadData
   */
  deleteRoadTypeRequest(roadData) {
    const params = {
      'road_types_id': roadData.road_types_id,
    };

    this.sendDataAndCreateDialog(
      '/api/road-type/delete-road-type',
      params,
      `${this.road_type} ${this.deleted.toLowerCase()}`,
      false,
      true,
    );
  }


  /**
   *
   * @param roadParams
   */
  saveRoadParams(roadParams: any) {
    this.sendDataAndCreateDialog(
      '/api/road-params/set-road-params',
      roadParams,
      `"${this.road_parameters}" ${this.created.toLowerCase()}`,
      true,
      false,
    );
  }

  /**
   * Set selected road type.
   * @param e
   */
  selectRoadType(e: any) {
    this.selRoadType = e;
    this.newRoadType = null;
    this.roadTypeSel = e;
  }

  /**
   * Send data to API ang create Dialog
   * @param url
   * @param params
   * @param text
   * @param redirect
   * @param getDataByDefault
   */
  sendDataAndCreateDialog(url: string, params: any, text: string, redirect?: any, getDataByDefault?: any) {

    this.http.post(url, params).subscribe((res: HttpResponse<any>) => {
      let createDialog = this.dialog.open(DialogRoadLaneComponent, <MatDialogConfig>{
        data: {
          act: '',
          text: text,
          icon_class: "dialog-icon-success",
          className: true
        }
      });
      createDialog.afterClosed().subscribe(async () => {
        this.disableButton = false;
        this.dialog.closeAll();
        redirect ? await this.redirect() : false;
        getDataByDefault ? await this.getDataByDefault() : false;
      });
    }, (error) => {
      if (error.status !== 401 && error.status !== 403 && this.Globals.error) {
        this.Globals.error = false;
        const errorDialog = this.dialog.open(DialogRoadLaneComponent, <MatDialogConfig>{
          data: {
            act: 'error',
            text: this.error_data,
            icon_class: 'dialog-icon-warning'
          }
        });
        errorDialog.afterClosed().subscribe(async () => {
          this.disableButton = false;
          this.dialog.closeAll();
        });
      }
    })
  }

  redirect() {
    if (this.sensorId)
      return this.router.navigate([`/admin/admin-sensors/${this.sensorId}/general`]);
  }

  async getSensorRoadTypes() {
    try {
      let res = await this.http.get('/api/admin-sensors/get-dict-sensor-roads-types').toPromise();
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Check if road type uses in system.
   * @param roadData
   */
  async checkRoadTypeInSystem(roadData): Promise<boolean> {
    let params: HttpParams = new HttpParams();
    if (roadData) {
      params = params.set('code', roadData.code);
    }
    try {
      let res = await this.http.get('/api/roads/type/in-system', {params}).toPromise();
      this.roads = res.body.roads;
      this.sensors = res.body.sensors;
    } catch (e) {
      console.log(e)
    }
    return true;
  }

  /**
   * Cut the header because they don't fit in the table
   * @param translate
   */
  shortPermitted(translate: any) {
    let shortStr: string = '';
    switch (this.Globals.lang) {
      case "ru":
        shortStr = translate.replace(/Максимальная/gi, 'Макс.');
        break;
      case "en":
        shortStr = translate.replace(/Maximum/gi, 'Max');
        break
      case "es":
        shortStr = translate.replace(/máxima/gi, "Máx")
        break
    }
    return shortStr;
  }

  shortMax(translate: any) {
    let shortStr: string = '';
    switch (this.Globals.lang) {
      case "ru":
        shortStr = translate.replace(/Максимальное количество/gi, 'Макс. Кол-во');
        break;
      case "en":
        shortStr = translate.replace(/Maximum number/gi, 'Max num');
        break
      case "es":
        shortStr = translate.replace(/Número máximo/gi, "Num Máx")
        break
    }
    return shortStr;
  }

  shortNum(translate: any) {
    let shortStr: string = '';
    switch (this.Globals.lang) {
      case "ru":
        shortStr = translate.replace(/Количество/gi, 'Кол-во');
        break;
      case "en":
        shortStr = translate.replace(/number/gi, 'Num');
        break
      case "es":
        shortStr = translate.replace(/Número/gi, "Num")
        break
    }
    return shortStr;
  }

  /**
   * Get all road types codes in system
   */
  public async fetchAllRoadTypesCodes() {
    try {
      let res = await this.http.get('/api/roads/all-road-types/codes').toPromise();
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Get road type for certain road
   * @param roadType
   */
  async getRoadType(roadType: any) {
    let params: HttpParams = new HttpParams();
    params = params.set('type', roadType);
    try {
      let res = await this.http.get('/api/roads/get-roads-type', {params}).toPromise();
      this.roadType = res.body;
      return this.roadType;
    } catch (e) {
      console.log(e)
    }
  }

  ngOnDestroy() {
    if (Boolean(this.changeLangCancel))
      this.changeLangCancel.unsubscribe();
  }


}

